import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Result } from 'src/app/shared/result';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Loginmodel } from './loginmodel';
import { LocalstorageService } from 'src/app/global/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  getLan: any;

  constructor(private http: HttpClient) { 
    this.getLan = LocalstorageService.getLanguage('language');
  }

  public CheckLoginData(data: Loginmodel) {
 //   debugger;
    data.lan = this.getLan;
    return this.http.post<any>(`${environment.apiUrl}/Login/Login`, data)
  }
}
